var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('Button',_vm._g(_vm._b({staticClass:"mb-8",scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_c('IconAdd')]},proxy:true}])},'Button',_vm.$props,false),_vm.$listeners)),(_vm.description)?_c('span',{staticClass:"color-gray-700 fs-12"},[_vm._v(_vm._s(_vm.description))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }